module.exports = __webpack_public_path__ + "static/media/Emblem_Diamond.eb6d27e8.png";